<ng-container *ngIf="!isShortDescription">
  <span *ngIf="!isOpen"
    >{{ description.substring(0, maxCharacters).trim() }}...</span
  >
  <span *ngIf="isOpen">
    {{ description }}
  </span>
</ng-container>
<ng-container *ngIf="isShortDescription">
  {{ description }}
</ng-container>
<button
  *ngIf="description?.length >= maxCharacters"
  class="ml-1 text-vtmn-play-content-brand font-bold"
  type="button"
  (click)="seeMore()"
>
  {{ seeButtonTranslation }}
</button>
